module.exports = __webpack_public_path__ + "static/media/sticky_WhatRingsTrue.99f99819.png";